import React, { useEffect, useState } from 'react';
import { useApp } from '../context/AppContext';
import { useLoading } from '../context/LoadingContext';
import { useToast } from '../context/ToastContext';
import ConfirmModal from './ConfirmModal';

// Lets someone add or edit the note on their own existing check-in/out
// entry — self-service only, and only ever on a record that already
// exists. There's no way to create a brand-new backdated entry from here;
// if you never actually clocked in/out, there's nothing to attach a note
// to.
export default function EditNoteModal({ open, entry, contextLabel, onClose }) {
  const { editNote } = useApp();
  const { withLoading } = useLoading();
  const { showSuccess, showError } = useToast();
  const [noteText, setNoteText] = useState('');

  useEffect(() => {
    if (open && entry) setNoteText(entry.notes || '');
  }, [open, entry]);

  const handleSave = async () => {
    try {
      await withLoading(() => editNote({ logId: entry.log_id, notes: noteText }));
      showSuccess('Note saved.');
      onClose();
    } catch (err) {
      showError(err.message || "Couldn't save that — please try again.");
    }
  };

  return (
    <ConfirmModal
      open={open}
      title={entry?.isIn ? 'Edit check-in note' : 'Edit check-out note'}
      onCancel={onClose}
      footer={
        <div className="flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 py-2.5 rounded-xl font-medium border border-border text-ink hover:bg-card-tint transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="flex-1 py-2.5 rounded-xl font-semibold text-white bg-gold hover:bg-bronze transition-colors"
          >
            Save
          </button>
        </div>
      }
    >
      {contextLabel && <p className="text-xs text-muted mb-3">{contextLabel}</p>}
      <textarea
        value={noteText}
        onChange={(e) => setNoteText(e.target.value)}
        rows={4}
        placeholder="Note"
        className="w-full border border-border rounded-lg px-3 py-2 text-sm resize-none focus:outline-none focus:ring-2 focus:ring-gold"
      />
    </ConfirmModal>
  );
}
